export default {
  styleOverrides: {
    root: () =>
      ({
        border: '0',
      }),
  },
};
